module.exports = __webpack_public_path__ + "img/1440.76bc0339.jpg";